export const routerPaths = {
  login: "/login",
  home: "/home",
  fields: "/fields",
  realtime: "/realtime",
  wiki: "/wiki",
  field_add: "/fields/field-add",
  field_update: "/fields/field-update",
  shapefile: "/fields/shapefile",
  signup: "/signup",
  forgot_password: "/forgot-password",
  reset_password: "/reset-password",
};
